
import { Collapse, Grid, Typography, useTheme } from "@mui/material";
import {  useState } from "react";
import { IEditTagSearchResultDeviceDTO } from "../../../services/setpoint-administration-service/Models";
import { ExpandMore } from "@mui/icons-material";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';


export type UsageSummaryListItemProps = {
    item: IEditTagSearchResultDeviceDTO,
};

export function UsageSummaryListItem({
    item,
}: UsageSummaryListItemProps) {

    const [expanded, setExpanded] = useState(false);

    const theme = useTheme();



    const tags = item.tags.filter(o => o.selected);


    function toggleExpanded() {
        setExpanded(!expanded);
    }    

    function renderTags() {

        return tags.map(o => {
            return (
                <Grid
                    key={o.id}
                    sx={{
                        paddingTop: `${theme.spacing(1)}!important`,
                        //padding: 1,
                          // backgroundColor: "custom.background.1",

                }}
                    size={{
                        xs: 2,
                        sm: 2,
                        md: 3
                    }}>
                    <Typography variant='body2' 
                        component='div'
                        noWrap={false}>
                        {o.name}
                    </Typography>
                </Grid>
            );});
    }
    
    return (
        <>
            <ListItemButton onClick={toggleExpanded}>
              <ListItemText primary={item.name} />
              <ExpandMore sx={{
                          transform: !expanded ? "rotate(0deg)" : "rotate(180deg)",
                          transition: theme.transitions.create('transform', {
                              duration: theme.transitions.duration.shortest,
                          })
                      }} />
            </ListItemButton>
            <Collapse in={expanded} timeout="auto" unmountOnExit>

                {
                expanded && <ListItemText sx={{marginLeft: 1,
                      marginTop: 4,
                      marginRight: 2,
                      backgroundColor: "custom.background.1",
                      borderRadius: '3px'
                      
                      }}>

                      <Grid container 
                        spacing={{ xs: 3, md: 4 }} 
                        columns={{ xs: 2, sm: 4, md: 12}} 
                        sx={{
                            padding: 2
                        }}>
                      {
                          renderTags()
                      }
                      </Grid>


                </ListItemText>
                }

            </Collapse>
        </>
    );
}
